import {TAppInitialController} from 'core/redux/types';
import {actionSetBreadCrumbsList} from 'modules/breadcrumbs/slice';
import {getBreadCrumbsList} from 'modules/breadcrumbs/thunks';
import {getCategoryIdListHelper} from 'modules/categories/helpers';
import {setIsSelection} from 'modules/products/helpers';
import {PAGES} from 'routing/constants';
import {findPage} from 'routing/helpers';

export const breadCrumbsController: TAppInitialController<void> = async (store, ctx) => {
    const {dispatch} = store;
    const page = findPage(ctx.query.path);
    const isSelection = setIsSelection(ctx.query.path);
    if (isSelection && page) {
        dispatch(actionSetBreadCrumbsList([PAGES.HOME_PAGE, PAGES.CATALOG_PAGE, page]));
        return;
    }

    const categoryIdList = await getCategoryIdListHelper(store, ctx);
    if (!categoryIdList) {
        return;
    }

    dispatch(getBreadCrumbsList(categoryIdList));
};
